/* eslint-disable operator-linebreak */
import React from 'react';
import { useLocation } from 'react-router-dom';

export default function Sidebar() {
  const location = useLocation();

  if (location?.pathname !== '/new-user-flow') {
    return null;
  }

  return (
    <div className="k-sidebar">
      <div className="k-sidebar-header">
        <h1 className="k-sidebar-header-text">How Katapult Works</h1>
      </div>
      <div className="k-sidebar-content">
        <ul className="k-icon-list">
          <li className="k-icon-tick">
            <h1>Get approved with no credit history required</h1>
            <p>Our application is short and sweet. Get a decision in seconds.</p>
          </li>
          <li className="k-icon-handbag">
            <h1>Go shopping</h1>
            <p>Select the items you want within your Katapult spending limit.</p>
          </li>
          <li className="k-icon-checkout">
            <h1>Checkout</h1>
            <p>Choose Katapult, make your initial payment, and enjoy your items.</p>
          </li>
          <li className="k-icon-calendar">
            <h1>Make recurring payments</h1>
            <p>The sooner you buyout your lease the more you save!</p>
          </li>
        </ul>
      </div>
    </div>
  );
}
